export async function sleep(millis: number) {
    function promiseSleep() {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve(undefined)
            }, millis)
        })
    }
    await promiseSleep()
}

export async function waitForElement<T>(retrieveElementFunc: Function, timeout = 2000) {
    const immediateRetriveAttempt = retrieveElementFunc()
    if (immediateRetriveAttempt != null) {
        Promise.resolve(immediateRetriveAttempt)
        return
    }

    return new Promise<T>(resolve => {
        const timeoutHandle = setTimeout(() => {
            clearInterval(retryIntervalHandle)
            resolve(null!)
        }, timeout)

        const retryIntervalHandle = setInterval(() => {
            const element = retrieveElementFunc()
            if (element != null) {
                clearTimeout(timeoutHandle)
                clearInterval(retryIntervalHandle)
                resolve(element)
            }
        }, 1)
    })
}